import { clientPath, lpRequest } from '../../../../core/utils/lp-backend';
import { getRegion } from './get-region';

/** `DELETE /client/:cid/regions/:id/hubs/:hub_id`. */
export const removeHub = async (region_id: string, hub_id: string): Promise<any> => {
  await lpRequest('DELETE', clientPath(`/regions/${region_id}/hubs/${hub_id}`));

  return getRegion(region_id);
};
